<script lang="ts">
	import "carbon-components-svelte/css/white.css";
	import {
		Button,
		Content,
		Header,
		HeaderNav,
		HeaderNavItem,
		HeaderNavMenu,
		HeaderPanelDivider,
		HeaderUtilities,
		Modal,
		SideNav,
		SideNavItems,
		SideNavLink,
		SkipToContent,
		SideNavMenu,
		SideNavMenuItem
	}from "carbon-components-svelte";
	import { Router, Route, navigate } from "svelte-navigator";
	import Login from "./components/Login.svelte";
	import {
		logInOut, 
		tenants, 
		selectedTenant, 
		isSelectedTenant, 
		userStore,
		selectedBuilding
	} from "./stores";
	import {Requests} from "./libreries/Requests";
	import { onMount } from "svelte";
	import Users from "./components/Users.svelte";
	import Bookings from "./components/Bookings.svelte";
	import BuildingStatus from "./components/BuildingStatus.svelte";
	import Invitations from "./components/Invitations.svelte";
	import Checkin from "./components/Checkin.svelte";
	import Presences from "./components/Presences.svelte";
	import type {Tenant} from "./models/Tenant";
	import GatesStatus from "./components/GatesStatus.svelte";
	import { UserModel } from "./models/UserModel";
	import DashboardVersion from "./components/DashboardVersion.svelte";
	import { CookiesHandler } from "./utilities/CookieHandler";
	
	let requests: Requests = new Requests();
	let isSideNavOpen: boolean = false;
	let tenantsList: Tenant[];
	let tenant: Tenant; //selected tenant
	let isTenant: boolean = false;
	$: components = [];
	let healthDictionary = {};
	let colorHealthPill: string	= "";
	let open: boolean = false;
	$: isLogged = false;
	$: userToken = "";
	$: me = {username: "", role: ""};
	$: screenWidth = 0; 

	//keep for logout-login
	$:if(userToken){
		getTenants();
		getHealthState();
		
	}

	onMount(() => {
		if(CookiesHandler.getTokenFromCookie('token')){
			userToken = CookiesHandler.getTokenFromCookie('token');
		}
		//for reload
		if(userToken){
			getTenants();
			getHealthState();
			getMe();
		}	
		logInOut.token.subscribe((value) =>{
			userToken = value;
			requests.currentToken = value;
		})
		logInOut.isToken.subscribe(async (value) => {
			isLogged = value;			
		});
		logInOut.user.subscribe((value) => {
			me = value;
			if(value.username === "" && userToken !== ""){
				getMe();
			}
		})
		//set the selectedTenant
		selectedTenant.subscribe((value) => {
			if(value.id !== ""){isSelectedTenant.set(true); tenant = value;}	
			userStore.selectedUser.set(new UserModel());
			userStore.isSelectUser.set(false);
			navigate('/');
		})

		tenants.subscribe((value) => {
			tenantsList = value;
		})

		isSelectedTenant.subscribe((value) => {
			isTenant = value;
		})
	})

	//open modal with health state
	function openModalHealth(){
		open = true;
	}

	//get the list of tenants
	async function getTenants(){
		tenantsList = await requests.getTenants();
		tenants.set(tenantsList);
	}

	async function getHealthState(){
		healthDictionary = await requests.getHealth();
		Object.keys(healthDictionary).forEach(key => {
			components = [];
			if(!components.some(y => y.key === key)){
				components.push({name: key, state: healthDictionary[key]});
			}			
		})
		//decide color of health global status
		let states: boolean[] = [];
		
		components.forEach((item) => {
			states.push(item.state);
		})
		if(states.find(e => e === false)){
			colorHealthPill = "error";
		}else{
			colorHealthPill = "good";
		}
	}

	async function getMe(){
		me = await requests.getMe();
	}
</script>
<svelte:window bind:innerWidth={screenWidth}/>
<main>
	<Header 
		company="SpaceTuner" 
		platformName="Support Console" 
		bind:isSideNavOpen 
		on:click={() => {
			userStore.selectedUser.set(new UserModel());
			userStore.isSelectUser.set(false);
			navigate('/');
		}}>
		<div slot="skip-to-content">
			<SkipToContent />
		</div>
		{#if isLogged}
		<HeaderNav>
		<Button kind="ghost" class="header-button" on:click={openModalHealth}>
			<span class="state-pill {colorHealthPill}"></span>Stato di salute</Button>
		<HeaderPanelDivider />
		<HeaderNavMenu text={isTenant ? tenant.name : "Seleziona il tenant"} style="font-weight: 600; color:#fff;">
			{#if tenantsList}
			{#each tenantsList as tenant, index}
				<HeaderNavItem text={tenant.name} on:click={() => {
						selectedTenant.set(tenant); 
						selectedBuilding.reset(); 
					}} />
			{/each}
			{/if}
		</HeaderNavMenu>	
		</HeaderNav>
		{/if}	
		<HeaderUtilities>
			{#if me}
				{#if me.username !== ""}
					<p id="logged-user">{me.username} - ruolo: {me.role}</p>
				{/if}
			{/if}
			<Button kind="ghost" class="header-button" on:click={requests.logOut}>Log out</Button>
		</HeaderUtilities>
	</Header>
	<Router>
		<SideNav bind:isOpen={isSideNavOpen}>
			{#if screenWidth < 1057}
				{#if isLogged}
					<Button kind="ghost" on:click={openModalHealth} style="display: flex;justify-content: flex-start;">
						<span class="state-pill {colorHealthPill}"></span>Stato di salute</Button>
					<SideNavMenu text={isTenant ? tenant.name : "Seleziona il tenant"} style="font-weight: 600;">
						{#if tenantsList}
						{#each tenantsList as tenant, index}
							<SideNavMenuItem text={tenant.name} on:click={() => {selectedTenant.set(tenant)}} />
						{/each}
						{/if}
					</SideNavMenu>
				{/if}	
			{/if}
			{#if isLogged && isTenant}
			<SideNavItems>
				<SideNavLink text="Utenti" on:click={() => {
						navigate('/')
					}}/>
				<SideNavLink text="Stato building" on:click={() => {
						navigate('/building-state')
					}} />
				<SideNavLink text="Prenotazioni" on:click={() => {
						navigate('/bookings')
					}}/>
				<SideNavLink text="Inviti" on:click={() => {
					navigate('/invitations')
					}} />
				<SideNavLink text="Check-in" on:click={() => {
					navigate('/check-in')
					}}/>
				<SideNavLink text="Presenze" on:click={() => {
					navigate('/presences')
					}}/>
				<SideNavLink text="Varchi" on:click={() => {
					navigate('/gates')
					}}/>
			</SideNavItems>
			<DashboardVersion />
			{/if}
		</SideNav>
	
		<Content>
			{#if !isLogged}
			<Login />
			{:else}
				{#if components.length > 0}
				<Modal bind:open passiveModal modalHeading="Stato di salute generale">
					{#each components as item, index}			
						<div style="display: flex;" class="margin-bottom-16">
							<span class="state-pill {item.state ? "good" : "error"}"></span>
							<p>{item.name}</p>
						</div>						
					{/each}
				</Modal>
				{/if}
				{#if !isTenant}
				<h3>Seleziona un tenant</h3>
				{:else}
				<Route path="/">
					<Users requests={requests} />
				</Route>
				<Route path="/building-state" primary={false}>
					<BuildingStatus requests={requests} />
				</Route>
				<Route path="/bookings" primary={false}>
					<Bookings requests={requests} />
				</Route>
				<Route path="/invitations" primary={false}>
					<Invitations requests={requests} />
				</Route>
				<Route path="/check-in" primary={false}>
					<Checkin requests={requests} />
				</Route>
				<Route path="/presences" primary={false}>
					<Presences requests={requests} />
				</Route>
				<Route path="/gates" primary={false}>
					<GatesStatus requests={requests} />
				</Route>
				{/if}
			{/if}
		</Content>
	</Router>
</main>